import { ChatBubble, Delete, Info, MoreVert, Person } from '@mui/icons-material';
import { ListItem } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Meetingroom, Network } from '../../../../../interfaces/interfaces';
import { fetchAndSetNetworks } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../reduxToolkit/typedRedux';
import { deleteNetwork } from '../../../../../services/services';
import { MeetingroomDetailsModal } from '../../../../account/meetingrooms/MeetingroomDetailsModal';
import { VyConfirm } from '../../../../common/VyConfirm';
import { VyExportButton } from '../../../../common/VyExportButton';
import VyPopoverMenu from '../../../../common/VyPopoverMenu';
import HeaderButton from '../../../../common/HeaderButton';

const NetworkPopoverSettings = ({ network, onDelete }: { network: Network; onDelete: () => void }) => {
  const event = useSelector((state) => state.common.event);

  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const { t } = useTranslation('pagebuilder');
  const dispatch = useDispatch();

  async function handleDeleteNetwork(id: string) {
    if (!event) return;
    await deleteNetwork(id);
    dispatch(fetchAndSetNetworks(event?._id));
  }

  async function handleModalClose() {
    setShowDetailsModal(false);
    if (!event) return;
    dispatch(fetchAndSetNetworks(event?._id));
  }

  return (
    <>
      <VyPopoverMenu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        content={(onClose) => (
          <div style={{ minWidth: '8rem' }} className="flex flex-col ">
            <HeaderButton
              Icon={Info}
              onClick={() => {
                setShowDetailsModal(true);
                onClose();
              }}
              flexDirection="flex-row"
              text={t('meeting:details.details')}
            />
            <VyExportButton
              csvURL={`/meeting/chat/export/${network?._id}?resType=csv`}
              xlsxURL={`/meeting/chat/export/${network?._id}?resType=xlsx`}
              axiosMethod="GET"
              modalContent={t('networking:chat-export-description')}
              className="mr-2"
              altButton={<HeaderButton Icon={ChatBubble} flexDirection="flex-row" text={t('networking:chat-export')} />}
            />
            <VyExportButton
              csvURL={`/reporting/meetinguserminutes/${network?._id}?resType=csv`}
              xlsxURL={`/reporting/meetinguserminutes/${network?._id}?resType=xlsx`}
              axiosMethod="GET"
              className="mr-2"
              modalContent={t('networking:meetinguserminutes-export-description')}
              filename={`export-${network?.name?.trim().replace(' ', '-')}`}
              altButton={<HeaderButton Icon={Person} flexDirection="flex-row" text={t('networking:user-export')} />}
            />
            <VyConfirm
              onConfirm={async () => {
                await handleDeleteNetwork(network._id);
                onDelete();
                onClose();
              }}>
              <HeaderButton Icon={Delete} flexDirection="flex-row" text={t('common:delete')} />
            </VyConfirm>
          </div>
        )}>
        <ListItem style={{ flex: 0 }} button>
          <MoreVert />
        </ListItem>
      </VyPopoverMenu>
      {showDetailsModal && <MeetingroomDetailsModal open={showDetailsModal} meeting={(network as unknown) as Meetingroom} onClose={handleModalClose} />}
    </>
  );
};
export default NetworkPopoverSettings;
